import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const PaymentSuccessPage = () => {
  const location = useLocation();
  const { refreshCredits } = useAuth();
  const [paymentDetails, setPaymentDetails] = useState({
    type: null,
    amount: null,
    plan: null,
    cycle: null
  });
  
  useEffect(() => {
    // Extract information from URL query parameters
    const params = new URLSearchParams(location.search);
    const type = params.get('type');
    const amount = params.get('amount');
    const plan = params.get('plan');
    const cycle = params.get('cycle');
    
    setPaymentDetails({ type, amount, plan, cycle });
    
    // Refresh credits data when returning from successful payment
    refreshCredits();
  }, [location.search, refreshCredits]);

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <div className="flex-grow flex flex-col items-center justify-center p-6">
        <div className="w-full max-w-md bg-white rounded-xl shadow-sm p-8 text-center">
          <div className="mb-6 flex justify-center">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>
          </div>
          
          <h1 className="text-2xl font-bold text-gray-800 mb-2">Payment Successful!</h1>
          
          {paymentDetails.type === 'credits' ? (
            <p className="text-gray-600 mb-6">
              You have successfully purchased {paymentDetails.amount} credits. 
              They have been added to your account and are ready to use.
            </p>
          ) : paymentDetails.type === 'subscription' ? (
            <p className="text-gray-600 mb-6">
              Thank you for subscribing to our {paymentDetails.plan} plan ({paymentDetails.cycle}).
              Your subscription is now active.
            </p>
          ) : (
            <p className="text-gray-600 mb-6">
              Your payment has been successfully processed.
            </p>
          )}
          
          <div className="space-y-3">
            <Link 
              to="/dashboard" 
              className="block w-full py-3 px-4 bg-gradient-to-r from-blue-500 to-indigo-600 text-white rounded-lg font-medium hover:shadow-lg hover:shadow-indigo-500/30 transition-all"
            >
              Go to Dashboard
            </Link>
            
            <Link
              to="/createdocument"
              className="block w-full py-3 px-4 border border-gray-300 text-gray-700 rounded-lg font-medium hover:bg-gray-50 transition-colors"
            >
              Create Document
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccessPage;